import "../css/Header.css"
import * as React from "react";
import { useLocation } from "react-router-dom";
import HeaderAdmin from "./HeaderAdmin";
import HeaderGen from "./HeaderGen";

/**
 * 表示画面によってヘッダを切り替える
 * @returns 
 */
function Header() {
  const location = useLocation();
  // console.log(location);


  if (location.pathname.startsWith("/G009")) {
    // ヘッダなし
    return;

  } else if (location.pathname.startsWith("/G")) {
    // 管理者用ヘッダ
    return <HeaderAdmin />;

  } else if (location.pathname == "/" || location.pathname.startsWith("/D")) {
    // 一般サイトヘッダ
    return <HeaderGen />;

  } else {
    // ヘッダなし
    return;
  }

}

export default Header;
